import React from 'react';
import type { LucideIcon } from 'lucide-react';
import {
  Building2,
  Calendar,
  CalendarClock,
  Car,
  CheckSquare,
  Clock,
  Flag,
  GraduationCap,
  HardHat,
  Home,
  Mail,
  MapPin,
  Phone,
  Route,
  Users,
  UtensilsCrossed,
  Wrench,
} from 'lucide-react';

/** Icon-Schlüssel in DB / API; Fallback bei unbekanntem Wert: Kalender-Uhr */
export const ACTIVITY_ICON_MAP: Record<string, LucideIcon> = {
  call: Phone,
  meeting: Users,
  task: CheckSquare,
  deadline: Flag,
  email: Mail,
  lunch: UtensilsCrossed,
  car: Car,
  hardhat: HardHat,
  graduation: GraduationCap,
  map_pin: MapPin,
  calendar: Calendar,
  clock: Clock,
  wrench: Wrench,
  home: Home,
  building: Building2,
  route: Route,
};

export function ActivityIcon({ iconId, className }: { iconId: string; className?: string }) {
  const Cmp = ACTIVITY_ICON_MAP[iconId] ?? CalendarClock;
  return <Cmp className={className} />;
}

/** Anzeige in Kalender / Lead-Detail, wenn die API noch keine Typen liefert (entspricht Server-Defaults). */
export const FALLBACK_ACTIVITY_TYPES: { id: string; label: string; icon: string }[] = [
  { id: 'call', label: 'Anruf', icon: 'call' },
  { id: 'site_visit', label: 'Kundenbesuch', icon: 'meeting' },
  { id: 'construction', label: 'Baustelle', icon: 'hardhat' },
  { id: 'drive', label: 'Fahrt', icon: 'car' },
  { id: 'task', label: 'Aufgabe', icon: 'task' },
  { id: 'training', label: 'Weiterbildung', icon: 'graduation' },
];

/**
 * Optionen für das Symbol-Dropdown unter „Aktivitätstypen“.
 * `label` ist die Kurzbeschreibung für aria-label / title (Tooltip), nicht die Zeilenüberschrift der Aktivität.
 */
export const ACTIVITY_ICON_CHOICES: { value: string; label: string }[] = [
  { value: 'call', label: 'Telefon' },
  { value: 'meeting', label: 'Personen / Besuch' },
  { value: 'task', label: 'Checkbox / Aufgabe' },
  { value: 'deadline', label: 'Fahne / Frist' },
  { value: 'email', label: 'E-Mail' },
  { value: 'lunch', label: 'Essen' },
  { value: 'car', label: 'Auto / Fahrt' },
  { value: 'hardhat', label: 'Helm / Baustelle' },
  { value: 'graduation', label: 'Weiterbildung' },
  { value: 'map_pin', label: 'Standort' },
  { value: 'calendar', label: 'Kalender' },
  { value: 'clock', label: 'Uhr' },
  { value: 'wrench', label: 'Werkzeug' },
  { value: 'home', label: 'Haus' },
  { value: 'building', label: 'Gebäude' },
  { value: 'route', label: 'Route' },
];
